import { Palette } from '../constants/palette';
/**
 * Colors are generically named (not descriptive of color) to tie
 * closely to their intended use in the UI/ align with the style guide.
 * If we ever add a new theme, i.e. "dark", we keep the same names and
 * simply swap out the Palette color values
 */
export const colors = {
    primary: Palette.darkBlue,
    secondary: Palette.white,
    cta: Palette.royalBlue,
    secondaryGray: Palette.gray96,
    // this our brand color -- only used in logos (prob won't be used much)
    brand: Palette.updaterRed,
    hover: Palette.royalBlue80,
    active: Palette.royalBlue90,
    visited: Palette.royalBlue90,
    disabled: Palette.gray90,
    info: Palette.blue,
    confirmation: Palette.green,
    warning: Palette.orange,
    pending: Palette.orange,
    error: Palette.red,
    link: Palette.royalBlue,
    text: Palette.darkBlue,
    softerBlue: Palette.softerBlue,
    navBarActiveItem: Palette.white,
    navbarText: Palette.gray40,
    navBarIconBackground: Palette.gray96,
    navBarActiveItemBackground: Palette.blue,
    navBarBackground: Palette.white,
    spinner: Palette.blue,
    transparent: Palette.transparent,
    itemHoverBackground: Palette.gray96,
    switchBackground: Palette.gray80,
    switchButton: Palette.gray94,
    success: Palette.green,
    reviewCardBackground: Palette.gray96,
    lightGray: Palette.gray60,
    gray90: Palette.gray90,
    cardIcon: Palette.lightBlue,
    border: Palette.gray80,
    containerBackground: Palette.gray96,
    white: Palette.white,
    divider: Palette.gray90,
    lightBlue: Palette.lightBlue,
    softBlue: Palette.blue20, // different from Palette.softBlue
    coral: Palette.coral,
    textSoft: Palette.gray40,
    darkGreen: Palette.darkGreen,
    darkBlue: Palette.darkBlue,
    mint25: Palette.mint25,
    mint80: Palette.mint80,
    gray98: Palette.gray98,
};
//# sourceMappingURL=data:application/json;base64,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